import Webforms from './common/webforms';
import CartDrawer from './common/cartDrawer';
import MenuMobile from './components/menuMobile';
import Popup from './components/popup';
import PopupSignup from './components/popup_signup';

import { getPriceProd, initPurchase, setFooterDropdowns, topBar } from './components/utilities';

// ==========================================
// LazyLoad
// ==========================================
window.lazyLoadOptions = {
  elements_selector: ".lazy",
  threshold: window.mobile ? 100 : 150
};
window.addEventListener("LazyLoad::Initialized", event => {
  window.lazyLoadInstance = event.detail.instance
}, false );

// ==========================================
// Inicialização
// ==========================================
console.log('%cVnda - Tecnologia em Ecommerce', 'color: #f88d5b; font-size: 15px; font-family: "Verdana", sans-serif; font-weight: bold;');

window.addEventListener('DOMContentLoaded', () => {
  Webforms.init();
  CartDrawer.init();
  MenuMobile.init();
  Popup.init();
  PopupSignup.init();

  topBar();
  initPurchase();
  getPriceProd();
  setFooterDropdowns();
});
